import { initialWindowType } from '@/hooks/media';
import { Modal } from '@bfe/moly';
import Image from 'next/image';
import styles from './index.module.scss';
import { HOME_POPUP_BONUS_ICON, JOIN_SUCESS_ICON } from '@/constants';
import { Button } from '@/components';
import { useFm } from '@web3/base-hooks';
import { useEffect } from 'react';
import { scTrack } from '@web3/base-tracking';
import { Event } from '@/config/track-config';
import { LoadingIcon } from '@bfe/moly-icons';

enum PageName {
  JoinPopupWeb3Conncected = 'JoinPopup_Web3Conncected',
  JoinPopupBybitConnected = 'JoinPopup_BybitConnected',
}

interface Props {
  visible: boolean;
  isLoading: boolean;
  onClose: () => void;
  mainText: string;
  bonusText: string;
  confirmBtnText: string;
  onConfirm: () => void;
  connectedType: 'WALLET' | 'SPOT';
}

const JoinedModal = ({
  visible,
  isLoading,
  onClose,
  mainText,
  bonusText,
  confirmBtnText,
  onConfirm,
  connectedType,
}: Props) => {
  const { isMobile } = initialWindowType;
  const fm = useFm();

  useEffect(() => {
    if (!visible) return;
    scTrack(Event.Web3PageView, {
      page_name:
        connectedType === 'WALLET'
          ? PageName.JoinPopupWeb3Conncected
          : PageName.JoinPopupBybitConnected,
    });
  }, [visible]);

  const Footer = () => (
    <div className={styles.footer}>
      <Button
        // className={styles.button}
        variant="primary"
        size={isMobile ? 'small' : 'middle'}
        disabled={isLoading}
        onClick={() => {
          scTrack(Event.Web3UserClick, {
            page_name:
              connectedType === 'WALLET'
                ? PageName.JoinPopupWeb3Conncected
                : PageName.JoinPopupBybitConnected,
            button_name:
              connectedType === 'WALLET' ? 'connectBybit' : 'connectWeb3',
          });
          onConfirm();
        }}
      >
        {isLoading ? (
          <LoadingIcon className={styles.loading} />
        ) : (
          confirmBtnText
        )}
      </Button>
      {/* <Button
        // className={styles.button}
        customType="gradient"
        variant="secondaryBrand"
        size={isMobile ? 'small' : 'middle'}
        onClick={onClose}
      >
        Skip
      </Button> */}
    </div>
  );

  return (
    <Modal
      modal={false}
      className={styles.modal}
      isMobile={isMobile}
      direction={!isMobile ? 'center' : 'bottom'}
      cancelText={false}
      onCancel={() => {
        onClose?.();
      }}
      open={visible}
      onOpenAutoFocus={(e) => e.preventDefault()}
      // contextWrapper={styles.contextWrapper}
      footer={<Footer />}
      footerWrapper={styles.footerWrapper}
    >
      <div className={styles.content}>
        <Image
          className={styles.mainIcon}
          loader={({ src }) => src}
          src={JOIN_SUCESS_ICON}
          width={72}
          height={72}
          alt=""
        />
        <h1 className={styles.title}>{fm('aidolRegisteredSuccessfully')}</h1>
        <ul className={styles.mainText}>
          <li>{mainText}</li>
        </ul>
        <div className={styles.bonus}>
          <Image
            className={styles.bonusIcon}
            loader={({ src }) => src}
            src={HOME_POPUP_BONUS_ICON}
            width={36.8}
            height={37.7}
            alt=""
          />
          <p className={styles.bonusText}>{bonusText}</p>
        </div>
      </div>
    </Modal>
  );
};

export default JoinedModal;
